module.exports = __webpack_public_path__ + "assets/benefits-shopping-cart-b836d2.svg";